import { AUTH_TYPES } from "../types/authTypes";

export const loginAction = (email, password) => {
  return {
    type: AUTH_TYPES.LOGIN_ACTION,
    email,
    password,
  };
};

export const LoginWithVerifyOTP = (otp, mobile) => {
  return {
    type: AUTH_TYPES.OTP_LOGIN_ACTION,
    otp,
    mobile,
  };
};

export const LoginWithVerifyEmailOTP = (otp, email) => {
  return {
    type: AUTH_TYPES.EMAIL_OTP_LOGIN_ACTION,
    otp,
    email,
  };
};

export const createUser = (
  name,
  email,
  company,
  mobile,
  businessType,
  countryName,
  countryCode,
  gstNumber,
  loadingPort,
  // portId,
  port,
  portPairs,
  referrer,
  status
) => {
    console.log('📤 createUser action called with referrer:', referrer); // Add debug log

  return {
    type: AUTH_TYPES.CREATE_USER,
    name,
    email,
    company,
    mobile,
    businessType,
    countryName,
    countryCode,
    gstNumber,
    loadingPort,
    // portId,
    port,
   portPairs,
   referrer,
   status
  };
};

export const forgotPassword = (emailId) => {
  return {
    type: AUTH_TYPES.FORGOT_PASSWORD,
    emailId,
  };
};

export const updatedPasswordAction = (password, token) => {
  return {
    type: AUTH_TYPES.UPDATE_PASSWORD,
    password,
    token,
  };
};
export const sendOtpAction = (mobile) => {
  return {
    type: AUTH_TYPES.SEND_OTP,
    mobile,
  };
};

export const verifyOTP = (code, mobile, email) => {
  return {
    type: AUTH_TYPES.VERIFY_OTP,
    code,
    mobile,
    email,
  };
};

export const getBusinessTypeOption = () => {
  return {
    type: AUTH_TYPES.GET_BUSINESS_TYPE_OPTION,
  };
};

export const updateAuthUser = (data) => {
  return {
    type: AUTH_TYPES.UPDATE_AUTH_USER,
    data,
  };
};

export const checkCurrentPassword = (data) => {
  return {
    type: AUTH_TYPES.CHECK_CURRENT_PASSWORD,
    data,
  };
};

export const resetPasswordToken = () => {
  return {
    type: AUTH_TYPES.RESET_PASSWORD_TOKEN,
  };
};
export const updateUserSubscription = (subscription) => ({
  type: 'UPDATE_USER_SUBSCRIPTION',
  payload: subscription,
});
